import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  gestao: "Gestão",
  financeiro: "Financeiro",
  administrativo: "Administrativo",
  comercial: "Gerente Comercial",
  vendedor: "Vendedor",
  autor: "Autor",
  prestador: "Prestador de Serviço",
};

export const SPECIALTIES = [
  "designer",
  "diagramador",
  "revisor",
  "capista",
  "editor",
  "ilustrador",
  "tradutor",
  "preparador",
];

export const SPECIALTY_LABELS = {
  designer: "Designer",
  diagramador: "Diagramador",
  revisor: "Revisor",
  capista: "Capista",
  editor: "Editor",
  ilustrador: "Ilustrador",
  tradutor: "Tradutor",
  preparador: "Preparador",
};

export const can = (user, action) => {
  if (!user || !user.role) return false;
  const r = user.role;
  const matrix = {
    view_financial: ["gestao", "financeiro"],
    view_commissions: ["gestao", "financeiro", "comercial", "vendedor"],
    manage_users: ["gestao"],
    manage_clients: ["gestao", "administrativo", "comercial", "financeiro"],
    edit_clients: ["gestao", "administrativo", "comercial"],
    delete_clients: ["gestao", "administrativo"],
    manage_sales: ["gestao", "comercial", "financeiro"],
    create_sales: ["gestao", "comercial", "financeiro", "vendedor"],
    manage_services: ["gestao", "administrativo"],
    manage_cash: ["gestao", "financeiro"],
    manage_payables: ["gestao", "financeiro"],
    receive_payments: ["gestao", "financeiro"],
    pay_commissions: ["gestao", "financeiro"],
    edit_commissions: ["gestao", "financeiro"],
    edit_receivables: ["gestao", "financeiro", "comercial"],
    view_audit: ["gestao"],
    view_reports: ["gestao", "financeiro", "comercial", "vendedor"],
    view_editorial: ["gestao", "administrativo", "financeiro", "comercial", "vendedor", "prestador"],
    generate_contracts: ["gestao", "administrativo"],
    manage_authors: ["gestao", "administrativo", "financeiro"],
    view_portal: ["autor"],
  };
  return (matrix[action] || []).includes(r);
};

export const isVendor = (user) => user?.role === "vendedor";
